var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"99c3a2ac09ad06656ba52d281d66617f1f8546e5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["steenbok@maexal"]={id:"99c3a2ac09ad06656ba52d281d66617f1f8546e5"};
      